module.exports = __webpack_public_path__ + "Roboto-Medium.4d9f3f9e5195e7b074bb.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/font/roboto/Roboto-Medium.eot
// module id = ../../../../angular-bootstrap-md/font/roboto/Roboto-Medium.eot
// module chunks = 3